module.exports = __webpack_public_path__ + "img/icon4.5812124f.png";